import React from 'react'
import axios from 'axios'
import Homepage from './HomePage'
import { GuestComp } from './GuestComp'
import { QuickComp } from './QuickComp'
import PodcastComp from './PodcastComp'
import { useEffect, useState } from 'react'
import { API_ROOT, webPath } from '../apiconfig'
import AdCarousel from '../ReusableComp/Carasoul'


function MainPageComp() {


  const [advertisementData, setAdvertisementData] = useState([]);
  const [postAdvertise, setPostAdvertise] = useState([]);
  const [footerAdvertise, setFooterAdvertise] = useState([]);

  const [className1, setClassName1] = useState("");


  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName1("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName1("loaded1");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          window.removeEventListener("scroll", handleScroll);
        }
      }, currentSection * 70);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setSectionClassName();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const fetchAdvertisementData = async () => {
      try {
        const response = await axios.get(`${API_ROOT}/api/advertisement/get_active`);
        setAdvertisementData(response.data);
        setPostAdvertise(response.data.filter(item => item.banner_type === "Post-1"))
        setFooterAdvertise(response.data.filter(item => item.banner_type === "Footer-3"))

      } catch (error) {
        console.error('Error fetching advertisement data:', error);
      }
    };

    fetchAdvertisementData();
  }, []);

  return (
    <>


      <Homepage />

      <PodcastComp />
      <GuestComp />

      <QuickComp />

      <div className="container container-max ">
        <div className="row mt-5 spaceincontentbottm">
          <div className="col-md-12 mb-2 ">
            {/* <div >
        {advertisementData && advertisementData.length > 0 && (
         <a href={`${advertisementData[2]?.dest_url}`}> <img
            style={{ width: "100%", height:"auto" }}
            src={`${webPath}${advertisementData[2]?.banner_img}`}
            alt={advertisementData[2]?.banner_name}  aria-label={advertisementData[2]?.banner_name}
            loading="lazy" width="640" height="360" /> </a>
        )}
        </div> */}
            <AdCarousel ads={footerAdvertise} className={className1} />
          </div>
        </div>
      </div>

    </>
  )
}

export default MainPageComp

